<template>
  <div>
    <keypad
      :username = "username"
      :number = "number"
      :digit = "digit"
      :clear = "clear"
      :hangupCause = "hangupCause"
      >
    </keypad>
    <div class="row phone-row">
      <div class="col-3 offset-3">
        <b-button variant="primary" :disabled="audioOnly" @click="makeVideoCall">
          <i class="mdi mdi-video"></i>
        </b-button>
      </div>
      <div class="col-3">
        <b-button id="place_call" variant="success" @click="makeCall">
          <i class="mdi mdi-phone"></i>
        </b-button>
      </div>
      <div class="col-2" style="min-height: 50px;">
        <div class="dig" v-if="number.length > 0">
          <i class="mdi mdi-backspace"  @mouseup="mouseupBackspace" @mousedown="mousedownBackspace" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import keypad from './Keypad'

export default {
  name: 'dial',
  components: {
    keypad
  },
  props: {
    username: {
      type: String,
      required: true
    },
    number: {
      type: String,
      default: ''
    },
    digit: {
      type: Function
    },
    clear: {
      type: Function
    },
    backspace: {
      type: Function
    },
    makeCall: {
      type: Function
    },
    makeVideoCall: {
      type: Function
    },
    hangupCause: {
      type: String,
      default: ''
    },
    audioOnly: {
      type: Boolean
    }
  },
  data () {
    return {
      backspacePressed: false
    }
  },
  methods: {
    mousedownBackspace () {
      var self = this
      self.backspacePressed = true
      setTimeout(() => {
        if (self.backspacePressed) {
          self.clear()
          self.backspacePressed = false
        }
      }, 1000)
    },
    mouseupBackspace () {
      var self = this
      if (self.backspacePressed) {
        self.backspace()
        self.backspacePressed = false
      }
    }
  }
}
</script>

<style scoped>

#call:hover {
  background-color: #81c784;
}

.btn.btn-rounded {
  border-radius: 10px;
  color: #ffffff;
  width: 100%;
  height: 42px;
  cursor: pointer;
}

.phone-row {
  margin: 0 auto !important;
  max-width: 320px !important;
  clear: both !important;
  text-align: center !important;
  font-family: 'Exo' !important;
}

.phone-btn {
  min-width: 140px;
}

.digit,
.dig {
  cursor: pointer;
  font-size: 1.5em;
}

.digit:active,
.dig:active {
  background-color: #e6e6e6;
}

</style>
